module.exports = __webpack_public_path__ + "static/img/case-zlj-page-bg-06.1039cb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zlj/case-zlj-page-bg-06.jpg
// module id = +bjt
// module chunks = 1